import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

const KEYS = {
  38: 'up',
  40: 'down',
  27: 'esc',
};

const enhanceKeysNavigationHOCGenerator = (Component, { linksDOMSelector }) => {
  function EnhanceKeysNavigationHOC(props) {
    const { createdRef, dropdownDisplayed, closeDropdownAndResetMatches } = props;

    useEffect(() => {
      const domRef = createdRef.current;

      const keyDownListener = (e) => {
        const key = KEYS[e.keyCode];
        const linksNodeList = domRef && domRef.querySelectorAll(linksDOMSelector);
        const links = [...linksNodeList];

        if (!key || isEmpty(links)) {
          return;
        }

        e.preventDefault();
        const currentIndex = links.indexOf(document.activeElement);

        switch (key) {
          case 'up': {
            const prevIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : links.length - 1;
            const prevLink = links[prevIndex];
            prevLink.focus();
            break;
          }
          case 'down': {
            const nextIndex = currentIndex + 1 < links.length ? currentIndex + 1 : 0;
            const nextLink = links[nextIndex];
            nextLink.focus();
            break;
          }
          case 'esc':
            closeDropdownAndResetMatches();
            break;
          default:
            break;
        }
      };

      if (domRef && dropdownDisplayed) {
        domRef.addEventListener('keydown', keyDownListener);
      }

      return () => {
        domRef.removeEventListener('keydown', keyDownListener);
      };
    }, [dropdownDisplayed]);

    return <Component {...props} />;
  }

  EnhanceKeysNavigationHOC.propTypes = {
    createdRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    dropdownDisplayed: PropTypes.bool,
    closeDropdownAndResetMatches: PropTypes.func,
  };

  return EnhanceKeysNavigationHOC;
};

const enhanceKeysNavigation =
  ({ linksDOMSelector }) =>
  (Component) =>
    enhanceKeysNavigationHOCGenerator(Component, { linksDOMSelector });

export default enhanceKeysNavigation;
